import { Component, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { AbstractAppConfig } from '../../app.config';

@Component({
    selector: 'cut-header-bar',
    template: require('./header.html'),
    styles: [require('./header.scss')]
})
export class HeaderComponent {

  @Input()
  public title: string;

  @Input()
  public isSolicitor: boolean;

  @Input()
  public username: string;

  @Output()
  private signOutRequest: EventEmitter<any> = new EventEmitter();

  constructor(public appConfig: AbstractAppConfig) {
  }

  public signOut() {
    this.signOutRequest.emit();
  }
}
